import tooltip from '@/directives/tooltip.ts'

export default (app: any) => {
  app.directive('tooltip', tooltip)
}
